export const mapPlayerLiveView = (res) => {

    if (!res) return null
    const {players, ...rest} = res

    return {
        ...rest,
        players: players.map(({user, opponents, ...rest}) => ({
            ...rest,
            user: {
                ...user,
                lat: +user.lat,
                lng: +user.lng
            },
            opponents: {
                ...opponents,
                lat: +opponents.lat,
                lng: +opponents.lng
            },

        })),


    }
}


export const mapScoreCardDetails = (resData) => {


    if (!resData) return null

    const scoreCardList = resData.holepoints.map(({score, start_time, own_point, finish_time, holepoint}) => {

        const {hole_index, yards_and_par} = holepoint

        return {
            holeIndex: hole_index,
            points : own_point,
            score,
            startTime: start_time,
            finishTime: finish_time,
            yardsPar : yards_and_par

        }
    })



    return scoreCardList

}
